if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


// === Size deselection system ===
// Uses body classes like Todd Derman's approach for reliable state tracking.
// Unchecks size visually, uses L as silent fallback for variant resolution,
// periodic enforcement catches all re-renders.
document.addEventListener('DOMContentLoaded', function() {
  // Detect if product has a Size option
  var hasSizeOption = false;
  var fallbackSizeValueId = null;
  document.querySelectorAll('variant-selects fieldset').forEach(function(fs) {
    var legend = fs.querySelector('legend');
    if (legend && (legend.querySelector('.ig-size-label') || /size/i.test(legend.textContent))) {
      hasSizeOption = true;
      var lRadio = Array.from(fs.querySelectorAll('input[type="radio"]')).find(function(r) {
        return r.value === 'L';
      });
      if (lRadio) fallbackSizeValueId = lRadio.dataset.optionValueId;
    }
  });
  if (!hasSizeOption) return;

  document.body.classList.add('size-required');

  // --- Helper: find size fieldset (always re-queries) ---
  function getSizeFieldset() {
    var fieldsets = document.querySelectorAll('variant-selects fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend && (legend.querySelector('.ig-size-label') || /size/i.test(legend.textContent))) return fieldsets[i];
    }
    return null;
  }

  // --- Uncheck all size radios and clear label ---
  function uncheckSize() {
    if (document.body.classList.contains('size-user-selected')) return;
    var fs = getSizeFieldset();
    if (!fs) return;
    fs.querySelectorAll('input[type="radio"]').forEach(function(r) { r.checked = false; });
    var label = fs.querySelector('[data-selected-value]');
    if (label) label.textContent = '';
  }

  // Immediately uncheck
  uncheckSize();

  // --- Periodic enforcement (catches all AJAX re-renders) ---
  var enforceInterval = setInterval(function() {
    if (document.body.classList.contains('size-user-selected')) {
      clearInterval(enforceInterval);
      return;
    }
    uncheckSize();
  }, 100);

  // --- User explicitly selects a size (delegated on document, survives DOM replacement) ---
  document.addEventListener('change', function(e) {
    var radio = e.target;
    if (!radio.matches || !radio.matches('input[type="radio"]')) return;
    var fieldset = radio.closest('fieldset');
    if (!fieldset) return;
    var legend = fieldset.querySelector('legend');
    if (legend && (legend.querySelector('.ig-size-label') || /size/i.test(legend.textContent))) {
      document.body.classList.add('size-user-selected');
      clearInterval(enforceInterval);
    }
  });

  // --- Patch selectedOptionValues to include L fallback when no size checked ---
  document.querySelectorAll('variant-selects').forEach(function(picker) {
    var origGetter = Object.getOwnPropertyDescriptor(
      Object.getPrototypeOf(picker), 'selectedOptionValues'
    );
    if (origGetter && fallbackSizeValueId) {
      Object.defineProperty(picker, 'selectedOptionValues', {
        get: function() {
          var values = origGetter.get.call(this);
          var fs = getSizeFieldset();
          if (fs && !fs.querySelector('input:checked') && fallbackSizeValueId) {
            values.push(fallbackSizeValueId);
          }
          return values;
        }
      });
    }
  });

  // --- Block Add to Cart if no size selected (capture phase) ---
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('button[name="add"], .product-form__submit');
    if (btn && document.body.classList.contains('size-required') &&
        !document.body.classList.contains('size-user-selected')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Show error
      var pf = btn.closest('product-form');
      if (pf) {
        var wrapper = pf.querySelector('.product-form__error-message-wrapper');
        var msg = pf.querySelector('.product-form__error-message');
        if (wrapper && msg) {
          msg.textContent = 'Please select a size';
          wrapper.removeAttribute('hidden');
        }
      }

      // Shake the size pills
      var fs = getSizeFieldset();
      if (fs) {
        fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
        fs.classList.add('size-not-selected');
        setTimeout(function() { fs.classList.remove('size-not-selected'); }, 2000);
      }
    }
  }, true);

  // --- Auto-activate if URL has variant param (direct link) ---
  if (new URLSearchParams(window.location.search).has('variant')) {
    document.body.classList.add('size-user-selected');
    clearInterval(enforceInterval);
  }
});


// === Isle & Glen: fit the product title to one line (survives re-renders) ===
(function () {
  var SEL = '.product__title h1, h1.product__title';
  var raf;
  function fit() {
    var el = document.querySelector(SEL);
    if (!el) return;
    el.style.whiteSpace = 'nowrap';
    el.style.removeProperty('font-size');
    var size = parseFloat(getComputedStyle(el).fontSize) || 30;
    // Phones shrink a long title only a little, to 85% of full size (about 24px); past that the
    // ellipsis CSS in section-main-product.css ends it with "...". Wider screens shrink until it
    // fits. Chris, 2026-09-24.
    var phone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var floor = phone ? Math.round(size * 0.85) : 12;
    var guard = 0;
    while (el.scrollWidth > el.clientWidth + 1 && size > floor && guard < 100) {
      size -= 1;
      el.style.setProperty('font-size', size + 'px', 'important');
      guard++;
    }
  }
  function schedule() { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(fit); }
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(schedule); }
  var info = document.querySelector('product-info, .product__info-container');
  if (info && window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) { if (muts[i].type === 'childList') { schedule(); return; } }
    }).observe(info, { childList: true, subtree: true });
  }
  schedule();
})();


// === Isle & Glen: Size legend reads "Select a Size" until one is picked, then "Size: L" ===
(function () {
  function sizeFieldset() {
    var all = document.querySelectorAll('.product-form__input--pill');
    for (var i = 0; i < all.length; i++) {
      if (all[i].querySelector('.ig-size-label')) return all[i];
    }
    return null;
  }
  function update() {
    var fs = sizeFieldset();
    if (!fs) return;
    var label = fs.querySelector('.ig-size-label');
    if (!label) return;
    var checked = fs.querySelector('input[type="radio"]:checked');
    var picked = document.body.classList.contains('size-user-selected');
    var want = (checked && picked) ? ('Size: ' + checked.value) : 'Size: Select A Size';
    if (label.textContent !== want) label.textContent = want;
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.product-form__input--pill')) setTimeout(update, 0);
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.product-form__input--pill')) setTimeout(update, 60);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
  setTimeout(update, 400);
  try {
    new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  } catch (e) {}
  // Dawn swaps the variant-picker HTML on every selection, which restores the Liquid
  // default and made the chosen size flash then disappear — re-apply after each swap.
  try {
    var info = document.querySelector('.product__info-container');
    if (info) new MutationObserver(function () { update(); })
      .observe(info, { childList: true, subtree: true });
  } catch (e) {}
})();


// === Isle & Glen: size chart modal (open from the Size Chart link, in/cm toggle) ===
(function () {
  function modal() { return document.getElementById('igSizeChart'); }
  function open(e) {
    var m = modal(); if (!m) return;          // no modal -> let the link navigate
    e.preventDefault();
    // The modal is authored inside the Size fieldset, but .product__column-sticky
    // (and Dawn's transformed ancestors) break position:fixed — so portal it to
    // <body> before showing, otherwise it renders clipped inside the form column.
    if (m.parentElement !== document.body) document.body.appendChild(m);
    m.hidden = false;
    document.body.style.overflow = 'hidden';
    var c = m.querySelector('.ig-sc-close'); if (c) c.focus();
  }
  function close() {
    var m = modal(); if (!m) return;
    m.hidden = true;
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.ig-size-chart-link');
    if (link) { open(e); return; }
    if (e.target.closest && e.target.closest('.ig-sc-close')) { close(); return; }
    if (e.target.classList && e.target.classList.contains('ig-sc-overlay')) { close(); return; }
    var unit = e.target.closest && e.target.closest('.ig-sc-unit');
    if (unit) {
      var m = modal(); if (!m) return;
      var cm = unit.getAttribute('data-unit') === 'cm';
      m.querySelectorAll('.ig-sc-unit').forEach(function (b) {
        b.classList.toggle('is-active', b === unit);
      });
      m.querySelectorAll('.ig-sc-table td[data-in]').forEach(function (td) {
        var inches = parseFloat(td.getAttribute('data-in'));
        td.textContent = cm ? (Math.round(inches * 2.54 * 10) / 10) + ' cm' : inches + '"';
      });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();


// === Isle & Glen: Product Type pills -> sibling products of the same design ===
// Siblings are separate products (tee / sweatshirt / hoodie). Match them by
// normalising titles to a design "stem", mirroring brand_manager._title_stem.
(function () {
  // "long sleeve" is stripped here but NOT in the app's _title_stem — without it a
  // long-sleeve product's stem keeps the phrase and never matches its tee sibling.
  // The blank codes are listed one by one on purpose: a bare \d{4} would eat the
  // year out of titles like "Canada Est. 1867".
  var STRIP = /\b(hoodie|sweatshirt|sweat shirt|long ?sleeve|t-?shirts?|tees?|shirts?|front\/back print|front only|comfort colors|gildan \d+|1717|6014|18000|18500|3001|youth|kids|unisex)\b/gi;

  function stem(title) {
    var t = (title || '').toLowerCase();
    t = t.replace(/[-–]\s*\d{6,}\s*$/, '');
    t = t.replace(/[-–]\s*[a-z0-9_]*v\d+\s*$/, '');
    t = t.replace(/["']/g, ' ');
    t = t.replace(STRIP, ' ');
    t = t.replace(/[^a-z0-9 ]/g, ' ');
    return t.replace(/\s+/g, ' ').trim();
  }

  function typeOf(title) {
    var t = (title || '').toLowerCase();
    if (/hoodie/.test(t)) return 'hoodie';
    if (/long ?sleeve/.test(t)) return 'longsleeve';   // before tee: "Long Sleeve Tee"
    if (/sweatshirt|crewneck/.test(t)) return 'sweatshirt';
    return 'tee';
  }

  // One sibling lookup per design family. Picking a colour or size re-renders the pills
  // (see boot below), and every re-render reuses this instead of fetching again.
  var lookups = {};
  function siblings(myStem) {
    if (!lookups[myStem]) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(myStem) +
                '&resources[type]=product&resources[limit]=10';
      lookups[myStem] = fetch(url, { headers: { 'accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var list = (((data || {}).resources || {}).results || {}).products || [];
          var found = {};
          list.forEach(function (p) {
            if (stem(p.title) !== myStem) return;      // same design family only
            var t = typeOf(p.title);
            if (!found[t]) found[t] = p.handle;
          });
          return found;
        })
        .catch(function () {
          delete lookups[myStem];                      // let the next re-render retry
          return {};                                   // leave siblings hidden on failure
        });
    }
    return lookups[myStem];
  }

  async function resolve(fs) {
    if (!fs || !fs.dataset || fs.dataset.resolved) return;
    fs.dataset.resolved = '1';
    var myStem = stem(fs.getAttribute('data-product-title') || '');
    if (!myStem) return;
    var found = await siblings(myStem);
    fs.querySelectorAll('.ig-ptype-pill.is-pending').forEach(function (a) {
      var handle = found[a.getAttribute('data-type')];
      if (handle) {
        a.href = '/products/' + handle;
        a.hidden = false;
        a.classList.remove('is-pending');
      }
    });
    arrows(fs);
  }

  // Scroll arrows for the pill row (same behaviour as the live TT theme's
  // sibling pills): shown only when the row overflows — on mobile the 4th
  // pill (Hoodie) sits off-screen — and each tap nudges the row 60% of its
  // width. Runs after the sibling pills are revealed, since that is what
  // makes the row overflow. (Chris, 2026-09-08)
  function arrows(fs) {
    var row = fs.querySelector('.ig-ptype-row');
    var nav = fs.querySelector('[data-ig-ptype-nav]');
    if (!row || !nav || nav.dataset.wired) return;
    nav.dataset.wired = '1';
    var prev = nav.querySelector('[data-ig-ptype-prev]');
    var next = nav.querySelector('[data-ig-ptype-next]');
    var ro = null;
    function sync() {
      // A colour/size change swaps this fieldset out for a fresh one. Once it has left the
      // page, stop listening, or a resize listener piles up with every option change.
      if (!row.isConnected) {
        window.removeEventListener('resize', sync);
        if (ro) ro.disconnect();
        return;
      }
      var overflow = row.scrollWidth > row.clientWidth + 2;
      nav.hidden = !overflow;
      if (!overflow) return;
      prev.disabled = row.scrollLeft <= 2;
      next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
    }
    function nudge(dir) {
      // Instant, synchronous scroll: smooth scrollBy is silently dropped by some
      // engines (throttled tabs, older Safari), which made taps do nothing.
      row.scrollLeft = row.scrollLeft + dir * Math.max(120, row.clientWidth * 0.6);
      sync();
    }
    prev.addEventListener('click', function () { nudge(-1); });
    next.addEventListener('click', function () { nudge(1); });
    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    // Re-check once the web font lands and whenever the row or a pill changes size: the font
    // arriving after the last timed check left the row a few px too wide with no arrows, so
    // the Hoodie pill was simply cut off on desktop (Chris, 2026-09-11).
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
    if (window.ResizeObserver) {
      ro = new ResizeObserver(sync);
      ro.observe(row);
      Array.prototype.forEach.call(row.children, function (el) { ro.observe(el); });
    }
    sync();
    setTimeout(sync, 50);
    setTimeout(sync, 600);
    setTimeout(sync, 1500);
  }

  function resolveWithin(root) {
    if (root.matches && root.matches('.ig-ptype-fieldset')) resolve(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('.ig-ptype-fieldset').forEach(function (fs) { resolve(fs); });
    }
  }

  function boot() {
    resolveWithin(document);
    // Picking a colour or size makes product-info.js replace the whole <variant-selects>
    // block with fresh server HTML, where the sibling pills are hidden again. Resolve every
    // pill row that arrives (from the cached lookup, so no refetch and no flicker), or the
    // Long Sleeve / Sweatshirt / Hoodie pills vanish after one click (Chris, 2026-09-16).
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function (records) {
      records.forEach(function (rec) {
        rec.addedNodes.forEach(function (n) { if (n.nodeType === 1) resolveWithin(n); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();


// === Isle & Glen: no colour preselected on load; after a pick, only that colour's photos (2026-09-24) ===
// Chris: hiding the other colours' photos is right once someone chooses, but a colour preselected
// on load collapsed the gallery to one shirt before anyone had looked. So: nothing chosen on load
// (unless the link carries ?variant=, e.g. from an ad or a colour swatch, which means they already
// chose), every photo browsable, and the filter starts at the first real pick. Mirrors the size
// system above. The photo->colour map is rendered by snippets/product-media-gallery.liquid.
(function () {
  var VS = window.customElements && customElements.get('variant-selects');   // may not be defined yet
  var direct = new URLSearchParams(window.location.search).has('variant');
  var picked = direct;
  var fallbackId = null;
  var map = null;

  function isColourFs(fs) {
    var lg = fs && fs.querySelector('legend');
    return !!lg && /^\s*colou?r\b/i.test(lg.textContent || '');
  }
  function colourFs(root) {
    var all = (root || document).querySelectorAll('variant-selects fieldset');
    for (var i = 0; i < all.length; i++) if (isColourFs(all[i])) return all[i];
    return null;
  }
  function colourMap() {
    if (map) return map;
    var el = document.querySelector('script[data-ig-colour-media]');
    try { map = el ? (JSON.parse(el.textContent).media || {}) : {}; } catch (e) { map = {}; }
    return map;
  }

  // 1. Variant lookups still need a colour while none is chosen: use the one the page loaded with.
  //    Patched on the prototype (Dawn swaps the <variant-selects> element on every change), and
  //    before DOMContentLoaded so the size system's wrapper above wraps this one.
  function patchPicker(VS) {
    var d = Object.getOwnPropertyDescriptor(VS.prototype, 'selectedOptionValues');
    if (!d || !d.get || d.get.igColour) return;
    var get = function () {
      var values = d.get.call(this);
      var fs = colourFs(this);
      if (!picked && fallbackId && fs && !fs.querySelector('input:checked')) values.push(fallbackId);
      return values;
    };
    get.igColour = true;
    Object.defineProperty(VS.prototype, 'selectedOptionValues', { configurable: true, get: get });
  }
  if (VS) patchPicker(VS);
  else if (window.customElements) customElements.whenDefined('variant-selects').then(function () {
    patchPicker(customElements.get('variant-selects'));
  });

  // 1b. Dawn's own gallery update, on every option change, moves the variant's photo to the front
  //     of the gallery. Moving an <img> makes it re-draw: Chris saw the photo vanish, a small copy
  //     flash top-left, then the new one (2026-09-24). On products with a colour option this block
  //     decides what shows, so Dawn's shuffle is skipped altogether: nothing moves, nothing flashes.
  if (window.customElements) customElements.whenDefined('product-info').then(function () {
    var PI = customElements.get('product-info');
    var um = PI && PI.prototype.updateMedia;
    if (typeof um !== 'function' || um.igColour) return;
    var wrapped = function () {
      if (colourFs(this)) return;
      return um.apply(this, arguments);
    };
    wrapped.igColour = true;
    PI.prototype.updateMedia = wrapped;
  });

  // 2. Keep the swatches unchecked and the label honest until a real pick.
  function enforce() {
    if (picked) return;
    var fs = colourFs();
    if (!fs) return;
    fs.querySelectorAll('input[type="radio"]').forEach(function (r) {
      if (!fallbackId && r.checked) fallbackId = r.dataset.optionValueId;
      if (r.checked) r.checked = false;
    });
    var sv = fs.querySelector('[data-selected-value]');
    if (sv && sv.textContent !== 'Select A Color') sv.textContent = 'Select A Color';
  }

  // 3. Once a colour is picked, hide the other colours' photos and thumbnails.
  function colourOf(attr) {                       // "template--123__main-456789" -> its colour
    var id = String(attr || '').split('-').pop();
    return colourMap()[id];
  }
  function applyFilter() {
    if (!picked) return;
    var fs = colourFs();
    var on = fs && fs.querySelector('input[type="radio"]:checked');
    if (!on) return;
    var want = on.value, changed = false;
    document.querySelectorAll('media-gallery li[data-media-id], media-gallery li[data-target]').forEach(function (li) {
      var c = colourOf(li.getAttribute('data-media-id') || li.getAttribute('data-target'));
      var off = !!c && c !== want;
      if (li.classList.contains('ig-colour-off') !== off) { li.classList.toggle('ig-colour-off', off); changed = true; }
    });
    // On phones the gallery's first photo sits in from the left edge (its own margin). That margin
    // moves to the first photo still showing, so a picked colour stays where the gallery began
    // instead of jumping left (Chris, 2026-09-24). CSS: .ig-colour-first in base.css.
    var lead = document.querySelector('media-gallery .product__media-list li[data-media-id]:not(.ig-colour-off)');
    document.querySelectorAll('media-gallery li.ig-colour-first').forEach(function (li) {
      if (li !== lead) li.classList.remove('ig-colour-first');
    });
    if (lead && !lead.classList.contains('ig-colour-first')) lead.classList.add('ig-colour-first');
    if (changed) {
      document.querySelectorAll('media-gallery slider-component').forEach(function (s) {
        if (typeof s.resetPages === 'function') s.resetPages();
      });
      // Show the picked colour's first photo, scrolling to it rather than moving it.
      var gallery = document.querySelector('media-gallery');
      var first = gallery && gallery.querySelector('li[data-media-id]:not(.ig-colour-off)');
      if (first && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(first.getAttribute('data-media-id'), false);
    }
    syncControls();
  }

  // 3a. Under the photo, "< 1/8 >" meant nothing once a colour is picked and one photo is left
  //     (and it kept counting the hidden ones). Chris, 2026-09-24: swap it for a hint pointing at the
  //     colour pills. A colour with several photos (front and back) keeps the arrows, recounted.
  function syncControls() {
    var viewer = document.querySelector('media-gallery slider-component[id^="GalleryViewer"]');
    if (!viewer) return;
    var visible = viewer.querySelectorAll('li[data-media-id]:not(.ig-colour-off)').length;
    var total = viewer.querySelector('.slider-counter--total');
    if (total && String(total.textContent).trim() !== String(visible) && typeof viewer.resetPages === 'function') viewer.resetPages();
    var buttons = viewer.querySelector('.slider-buttons');
    if (!buttons) return;
    var hint = viewer.querySelector('.ig-colour-hint');
    if (!hint) {
      hint = document.createElement('p');
      hint.className = 'ig-colour-hint caption is-off';
      buttons.insertAdjacentElement('afterend', hint);
    }
    // It names the colour in the photo, "(Hemp Shown)". Chris, 2026-09-24.
    var fs = colourFs();
    var on = fs && fs.querySelector('input[type="radio"]:checked');
    var text = on ? '(' + on.value + ' Shown)' : '';
    if (hint.textContent !== text) hint.textContent = text;
    var single = picked && visible <= 1;
    if (buttons.classList.contains('ig-colour-hidden') !== single) buttons.classList.toggle('ig-colour-hidden', single);
    if (hint.classList.contains('is-off') === single) hint.classList.toggle('is-off', !single);
  }

  // 3b. Have each colour's photos loaded before they are needed: the moment a pointer is over or
  //     pressing a swatch, and all of them quietly a few seconds after the page settles.
  function eager(colour) {
    document.querySelectorAll('media-gallery li[data-media-id]').forEach(function (li) {
      if (colour && colourOf(li.getAttribute('data-media-id')) !== colour) return;
      li.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    });
  }
  function swatchValue(t) {
    var el = t && t.closest && t.closest('label, input');
    if (!el) return null;
    var input = el.tagName === 'INPUT' ? el : document.getElementById(el.getAttribute('for') || '');
    return input && isColourFs(input.closest('fieldset')) ? input.value : null;
  }
  ['pointerover', 'pointerdown', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var v = swatchValue(e.target);
      if (v) eager(v);
    }, { passive: true });
  });
  window.addEventListener('load', function () { setTimeout(function () { eager(null); }, 2500); });

  // 4. A real colour pick switches everything on. Capture phase, so it lands before
  //    <variant-selects> reads selectedOptionValues and the fallback stays out.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[type="radio"]')) return;
    if (!isColourFs(t.closest('fieldset'))) return;
    picked = true;
    document.body.classList.add('colour-user-selected');
    setTimeout(applyFilter, 0);
  }, true);

  // 5. No Add to Cart until a colour is chosen. Registered before the size check (which runs at
  //    DOMContentLoaded), so colour, higher on the page, is asked for first.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="add"], .product-form__submit');
    if (!btn || picked) return;
    var info = btn.closest('product-info');
    var fs = info && colourFs(info);
    if (!fs) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var pf = btn.closest('product-form');
    var wrap = pf && pf.querySelector('.product-form__error-message-wrapper');
    var msg = pf && pf.querySelector('.product-form__error-message');
    if (wrap && msg) { msg.textContent = 'Please select a color'; wrap.removeAttribute('hidden'); }
    fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    fs.classList.add('size-not-selected');
    setTimeout(function () { fs.classList.remove('size-not-selected'); }, 2000);
  }, true);

  // 6. Keep it true across Dawn's re-renders: every option change swaps the picker's HTML.
  function tick() { enforce(); applyFilter(); }
  function boot() {
    if (!colourFs()) return;                        // no colour option on this product
    document.body.classList.add(direct ? 'colour-user-selected' : 'colour-required');
    tick();
    var info = document.querySelector('product-info') || document.body;
    if (window.MutationObserver) new MutationObserver(tick).observe(info, { childList: true, subtree: true });
    var n = 0, iv = setInterval(function () { tick(); if (++n > 30) clearInterval(iv); }, 100);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
